/* import __COLOCATED_TEMPLATE__ from './ach-account-info.hbs'; */
import Component from '@glimmer/component';
import styles from './ach-account-info.module.scss';

export default class SiteBillingAchAccountInfo extends Component {
  styles = styles;
}
